import AutorenewIcon from '@mui/icons-material/Autorenew';
import { Button, styled } from '@mui/material';
import { RookeryBoldFont } from 'v3/styles/common';
import { CustomButtomProps } from './types';

export const MiniButtonStyles = styled(Button)<CustomButtomProps>(({ theme, $backgroundColor, $outline }) => ({
  font: `700 1rem ${RookeryBoldFont}`,
  textTransform: 'unset',
  width: '4.5rem',
  height: '2.5rem',
  borderRadius: '2.5rem',
  border: $outline ? '1px solid white' : 'unset',
  color: theme.palette.common.white,
  backgroundColor: $backgroundColor || theme.palette.tertiary.main,

  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },

  '&:hover': {
    backgroundColor: $backgroundColor || theme.palette.tertiary.light,
  },
  '&:disabled': {
    opacity: 1,
    backgroundColor: $backgroundColor || theme.palette.tertiary.main,
    color: theme.palette.common.white,
  },
}));

export const AutorenewIconStyles = styled(AutorenewIcon)(() => ({
  animation: 'spin 1s ease-in-out infinite',
  fontSize: '2rem',
  '@keyframes spin': {
    from: { transform: 'rotate(0deg)' },
    to: { transform: 'rotate(360deg)' },
  },
}));
